import React from "react";
import "./OverviewSection.css";

import healthIcon from "../Assets/icons/opnedicon.avif";
import rippleIcon from "../Assets/icons/networkicon.avif";
import communityIcon from "../Assets/icons/rounicon.avif";

const OverviewSection = () => {
  return (
    <section className="overview">

      <div className="overview-container">

        {/* Section Title */}
        <div className="overview-header">
          <h2>What is the Ripple Run?</h2>
          <div className="title-line"></div>
        </div>

        {/* Cards */}
        <div className="overview-cards">

          {/* Card 1 */}
          <div className="overview-card">

            <img src={healthIcon} alt="Health Run" />

            <h3>Annual Health Run</h3>

            <p>
              Ripple Run is not just a race. It is a movement, where one
              person’s step creates a ripple of health, hope, and impact
              across communities in Ghana. The event supports health,
              wellness, clean water, children, and future generations.
            </p>

          </div>


          {/* Card 2 */}
          <div className="overview-card">

            <img src={rippleIcon} alt="Ripple Effect" />

            <h3>The Ripple Effect</h3>

            <p>
              Every step taken during Ripple Run contributes to a ripple
              effect that brings positive changes to communities in Ghana.
              By participating, you support real impact in health, water,
              and children's welfare.
            </p>

          </div>


          {/* Card 3 */}
          <div className="overview-card">

            <img src={communityIcon} alt="Community Health" />

            <h3>Building Community Health</h3>

            <p>
              Ripple Run is about fostering a sense of community and
              promoting health and wellness in Ghana. It aims to bring
              people together for a common cause that transcends running.
            </p>

          </div>

        </div>

      </div>

    </section>
  );
};

export default OverviewSection;